<template>
<v-col cols="12">
  <div class="v-timeline-item">
    <!-- <span class="customTextDot">
      {{dateTime.arrival | timeToReadableTzCoordinates(dateTime.coordinates)}} - {{ dateTime.departure | timeToReadableTzCoordinates(dateTime.coordinates)}}
    </span> -->
    <span class="customTextDot">
      {{dateTime.arrival | timeToReadableSchedule(dateTime.coordinates)}} - {{ dateTime.departure | timeToReadableSchedule(dateTime.coordinates)}}
    </span>
    <span class="customTextDot date">
      {{dateTime.arrival |dateToReadableTzCoordinates(dateTime.coordinates)}}
    </span>
  </div>
</v-col>
</template>
<script>
export default {
  name: 'DropDatetimeItem',
  props: {
    dateTime: Object
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
  .v-timeline-item {
    padding: 0;
    position: relative;
    height: 50px;
    .customTextDot {
      font-size: 12px;
      font-weight: bold;
      background-color: #eeeeee;
      color: #212121;
      position: absolute;
      text-align: center;
      display: inline-block;
      white-space: nowrap;
      left: 0;
      top: 5px;
      &.date {
        font-size: 10px;
        top: 20px;
        color: #777777;
      }
    }
  }
</style>
